import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as userActions from "../../redux/actions/usersActions";
import { useTranslation } from 'react-i18next';

const getToken = location => new URLSearchParams((location && location.search) || "").get("token");

export function EmailVerificationPage({ location, confirmEmailVerification }) {
  const { t: tr } = useTranslation();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const token = getToken(location);
    if (!token) {
      setStatus("error");
      return;
    }

    confirmEmailVerification(token)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [location, confirmEmailVerification]);

  return (
    <div className="quiz-text email-verification-page">
      {status === "loading" && (
        <div role="status" className="alert alert-info email-verification-message">{tr("auth:verifyPending")}</div>
      )}
      {status === "success" && (
        <div role="status" className="alert alert-success email-verification-message">
          <h2>{tr("auth:verifySuccess")}</h2>
          <p>{tr("auth:verifySignIn")}</p>
          <Link className="btn manage-button manage-red-button" to="/manage/login">{tr("auth:goToSignIn")}</Link>
        </div>
      )}
      {status === "error" && (
        <div role="alert" className="alert alert-danger email-verification-message">
          <h2>{tr("auth:verifyFailed")}</h2>
          <p>{tr("auth:verifyExpired")}</p>
          <p>{tr("auth:verifyRetry")}</p>
          <Link className="btn manage-button manage-red-button" to="/manage/login">{tr("auth:goToSignIn")}</Link>
        </div>
      )}
    </div>
  );
}

EmailVerificationPage.propTypes = {
  location: PropTypes.shape({ search: PropTypes.string }),
  confirmEmailVerification: PropTypes.func.isRequired,
};

EmailVerificationPage.defaultProps = {
  location: { search: "" },
};

export default connect(null, {
  confirmEmailVerification: userActions.confirmEmailVerification,
})(EmailVerificationPage);
